import { replaceHtmlEntities } from "@/src-refactor/modules/shared/helpers/parse-html-values";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

const position: { [key: string]: I_GENERIC_ITEMS } = {
  ["Esquina"]: {
    label: "Esquina",
    value: 175,
    id: 175,
    name: "Esquina",
    extraData: {
      type: "Ubicación"
    }
  },
  ["Medial"]: {
    label: "Medial",
    value: 174,
    id: 174,
    name: "Medial",
    extraData: {
      type: "Ubicación"
    }
  }
};

interface ImprovementsToClient {
  use: I_GENERIC_ITEMS<{ type: string }>[];
  position: I_GENERIC_ITEMS<{ type: string }>[];
  features: I_GENERIC_ITEMS<{ type: string }>[];
  characteristicsFrames: I_GENERIC_ITEMS<{ type: string }>[];
  characteristicsDoors: I_GENERIC_ITEMS<{ type: string }>[];
  characteristicsClosets: I_GENERIC_ITEMS<{ type: string }>[];
  characteristicsCabinets: I_GENERIC_ITEMS<{ type: string }>[];
  characteristicsFloors: I_GENERIC_ITEMS<{ type: string }>[];
  characteristicsWindows: I_GENERIC_ITEMS<{ type: string }>[];
  characteristicsTypeHouse: I_GENERIC_ITEMS<{ type: string }>[];
  characteristicsRoof: I_GENERIC_ITEMS<{ type: string }>[];
  characteristicsRoofForm: I_GENERIC_ITEMS<{ type: string }>[];
}

const prepareImprovements = (res: IPropertyDetailsResponse) => {
  const ImprovementsObj: ImprovementsToClient = {
    use: [],
    position: [],
    features: [],
    characteristicsFrames: [],
    characteristicsDoors: [],
    characteristicsClosets: [],
    characteristicsCabinets: [],
    characteristicsFloors: [],
    characteristicsWindows: [],
    characteristicsTypeHouse: [],
    characteristicsRoof: [],
    characteristicsRoofForm: []
  };

  if (res?.improvements_list) {
    res?.improvements_list.forEach(item => {
      if (item.name === "Uso") {
        ImprovementsObj.use.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id,
          extraData: {
            type: "Uso"
          }
        });
      }
      if (item.name === "Ubicaci&oacute;n") {
        const positionItem = position[item.value];
        if (positionItem) {
          ImprovementsObj.position.push(positionItem);
        }
      }
      if (item.name === "Marcos") {
        ImprovementsObj.characteristicsFrames.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id,
          extraData: {
            type: "Marcos"
          }
        });
      }
      if (item.name === "Gabinetes") {
        ImprovementsObj.characteristicsCabinets.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id,
          extraData: {
            type: "Gabinetes"
          }
        });
      }
      if (item.name === "Puertas") {
        ImprovementsObj.characteristicsDoors.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id,
          extraData: {
            type: "Puertas"
          }
        });
      }
      if (item.name === "Ventanas") {
        ImprovementsObj.characteristicsWindows.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id,
          extraData: {
            type: "Ventanas"
          }
        });
      }
      if (item.name === "Pisos") {
        ImprovementsObj.characteristicsFloors.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id,
          extraData: {
            type: "Pisos"
          }
        });
      }
      if (item.name === "Techo") {
        ImprovementsObj.characteristicsRoof.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id,
          extraData: {
            type: "Techo"
          }
        });
      }
      if (item.name === "Mejoras") {
        ImprovementsObj.features.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id,
          extraData: {
            type: "Mejoras"
          }
        });
      }
      if (item.name == "Closets") {
        ImprovementsObj.characteristicsClosets.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id,
          extraData: {
            type: "Closets"
          }
        });
      }
      if (item.name == "Forma techo") {
        ImprovementsObj.characteristicsRoofForm.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id,
          extraData: {
            type: "Forma techo"
          }
        });
      }

      if (item.id == 5) {
        ImprovementsObj.characteristicsTypeHouse.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id,
          extraData: {
            type: replaceHtmlEntities(item.name || "Tipo de casa")
          }
        });
      }
    });
  }

  return ImprovementsObj;
};
export default prepareImprovements;
